import {UseQueryOptions} from "@tanstack/react-query/src/types";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getMonitorWFTable, MonitorWFApiParams} from "@commons/services/presenze_api/monitorWF.api";
import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import {DashboardWFRootDetails} from "@commons/mapping/dashboard.types";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import axios, {AxiosError, AxiosResponse} from "axios";
import {config} from "@commons/config.instance";
import {addBaseQueryParams} from "@commons/utils/APIParams";

export type AzioniMassiveType = 'RESPINGI' | 'ACCETTA' | 'RESETTA' | 'IN_VALUTAZIONE' | null;

export interface MonitorWFTableData extends DataTablesSchema<PresenzeCausaleWFRecord> {
    details: DashboardWFRootDetails
}

export interface AzioneMassivaData {
    tipo: AzioniMassiveType,
    numRecordsAggiornati?: number,
    numRecordsInErrore?: number,
    richieste: number[] | null,
}

export function useMonitorWFTable(params: MonitorWFApiParams, opt?: UseQueryOptions) {
    return useQuery<MonitorWFTableData, Error>({
        queryKey: ['monitorWFTable', params],
        queryFn: () => getMonitorWFTable(params),
        enabled: !!MonitorWFApiParams.isValid(params),
    })
}

export function usePatchOpeMassivaMonitor(params: MonitorWFApiParams, onSuccess?: (msg: string) => void, onError?: () => void,) {
    const queryClient = useQueryClient();
    params = {...params, stati: params.stati}
    return useMutation<AxiosResponse<AzioneMassivaData>, AxiosError, AzioneMassivaData>({
        mutationFn: (data) => {
            const params2: string[] = addBaseQueryParams(params);
            params2.push(...MonitorWFApiParams.setupCustomParams(params));
            const tipo = data.tipo?.toLocaleLowerCase();
            const url = config.getBaseUrl('FPNet') + `/tool/${params.idAziendaMaster}-${params.idAzienda}/workflow/${tipo}?${params2.length > 0 ? encodeURI(params2.join("&")) : ''}`;
            return axios.patch(url, data);
        },
        onSuccess: (res, variables, context) => {
            queryClient.invalidateQueries({queryKey: ['monitorWFTable']});

            let dettagli = `Richieste aggiornate: ${res.data.numRecordsAggiornati} `;
            if (res.data.numRecordsInErrore && res.data.numRecordsInErrore > 0) {
                dettagli = dettagli + `Operazioni fallite: ${res.data.numRecordsInErrore}`;
            }
            if (onSuccess)
                onSuccess(dettagli);
        },
        onError: (error, variables, context) => {
            if (onError)
                onError();
        },
    })
}